module.exports = __webpack_public_path__ + "img/ricelog_pinicon_061.ebcc3c0f.png";